<template>
    <div class="customer-center">
        <div class="page-header">
            <div class="title" v-html="$translate('CUSTOMER_CENTER')" />
        </div>
        <div class="section" :key="idx" v-for="(section, idx) in sections">
            <div class="sub-title" v-html="section[0].title" />
            <div
                @click="handler(item)"
                class="item flex-row items-center flex-between"
                :key="item.key"
                v-for="item in section"
            >
                <div class="title flex-row">
                    <span v-html="$translate($case.toConst(item.key))" />
                    <span v-if="item.anyChange" class="any-change" />
                </div>
                <!-- <i class="material-icons">chevron_right</i> -->
            </div>
        </div>
        <!-- <div class="item m-t-12">
            <div class="title" v-html="$translate('PLUS_FRIEND')" @click="modal()" />
            <div class="desc">
                <span v-html="$translate('PLUS_FRIEND_DESC')" />
                <i @click="showInfo" class="material-icons-outlined"> info </i>
            </div>
        </div> -->
    </div>
</template>

<script>
export default {
    name: 'CustomerCenterPage',
    computed: {
        sections() {
            if (this.$isTester()) return []

            return [
                [
                    {
                        title: '환급',
                        key: 'refunds',
                        handler: () => this.$router.push({ name: 'Refund1Page' }),
                    },
                    {
                        key: 'refundHistories',
                        replace: 'RefundHistoriesPage',
                        anyChange: (this.$store.getters.refunds || []).some(
                            refund => [0, 2, 4].indexOf(refund.status) !== -1,
                        ),
                    },
                ],
                [
                    {
                        title: '기타',
                        key: 'changePhoneNumber',
                        replace: 'ChangePhoneNumberPage',
                    },
                    {
                        key: 'reportAgents',
                        replace: 'ReportAgentPage',
                    },
                    {
                        key: 'faq',
                        replace: 'FAQPage',
                    },
                    {
                        key: 'plusFriend',
                        // replace: 'FAQPage',
                    },
                ],
            ]
        },
    },
    mounted() {
        this.$store.dispatch('loadRefunds')
    },
    methods: {
        showInfo() {
            this.$alert(this.$translate('PLUS_FRIEND_BODY'))
        },
        handler(item) {
            if (item.key === 'refunds') {
                item.handler()
                return
            } else if (item.key === 'plusFriend') {
                this.modal()
                return
            }

            this.$stackRouter.push({
                name: item.replace,
            })
        },
        modal() {
            this.$modal.basic({
                body: this.$translate('PLUS_FRIEND_DESC') + '<br><br>' + this.$translate('PLUS_FRIEND_BODY_SHORT'),
                buttons: [
                    {
                        label: '확인',
                        class: 'btn-default',
                    },
                ],
            })
        },
    },
}
</script>
